module.exports = __webpack_public_path__ + "img/course70_curriculum.5b4889c4.jpg";